<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar hidden-print mb-4" slot="header">
			<h4 class="pull-left" v-if="mode === 'create'">
				{{ $t('promo-to-product.new-promo') }}
			</h4>
			<h4 class="pull-left" v-else>
				{{ $t('promo-to-product.promo') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i class="fa fa-close"></i></b-button>
			<b-button v-if="view" @click="print" class="pull-right mr-2" variant="outline-dark"><i class="fa fa-print"/> {{$t('pricing.print')}}</b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid id="newPromoId" class="promotion">
				<ValidationObserver
					ref="oneTimeDiscountObserver"
					v-slot="{}"
				>
					<b-row v-if="!view">
						<b-col cols="3">
							<label :for="department">{{ $t('promo-to-product.department') }} <span class="text-danger">*</span></label>
						</b-col>
						<b-col cols="9">
							<ValidationProvider
								name="department"
								ref="department"
								rules="required"
								v-slot="{errors}"
							>
								<b-form-group
									class="required"
									:state="errors.length <= 0"
									invalid-feedback="Bu maydon majburiy"
								>
									<multiselect
										v-model="department"
										:options="listWarehouse"
										id="department"
										name="deps"
										class="is-invalid required"
										track-by="id"
										label="name"
										:placeholder="$t('promo-to-product.department')"
									>
									</multiselect>
								</b-form-group>
							</ValidationProvider>
						</b-col>
					</b-row>
					<br v-if="!view">
					<b-row v-if="!view">
						<b-col cols="3">
							<label
								:for="form.startDiscountDate"
								:required="true"
							>{{ $t('promo-to-product.from') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="4">
							<ValidationProvider
								name="startDate"
								rules="required"
								v-slot="{errors}"
							>
								<b-form-group
									class="required"
									:state="errors.length <= 0"
									invalid-feedback="Bu maydon majburiy"
								>
									<date-picker
										style="margin-left: -16px"
										v-model="form.startDiscountDate"
										lang="ru"
										:required="true"
										:placeholder="$t('certificate.fromDate')"
										value-type="format"
										format="DD-MM-YYYY"
									></date-picker>
								</b-form-group>
							</ValidationProvider>
						</b-col>
						<b-col cols="3">
							<label :for="form.endDiscountDate">{{ $t('promo-to-product.finish-date') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="2">
							<ValidationProvider
								name="endDate"
								rules="required"
								v-slot="{errors}"
							>
								<b-form-group
									class="required"
									:state="errors.length <= 0"
									invalid-feedback="Bu maydon majburiy"
								>
									<date-picker
										style="margin-left: -100%"
										v-model="form.endDiscountDate"
										lang="ru"
										:placeholder="$t('certificate.fromDate')"
										value-type="format"
										format="DD-MM-YYYY"
									></date-picker>
								</b-form-group>
							</ValidationProvider>
						</b-col>
					</b-row>
					<br v-if="!view">
					<b-form-group v-if="!view">
						<b-row class="my-1">
							<b-col sm="3">
								<label :for="whDocument.regNumber">{{ $t('promo-to-product.invoice') }} <span
									class="text-danger">*</span></label>
							</b-col>
							<b-col sm="4">
								<b-form-input size="sm" id="name"
											  v-model="whDocument.regNumber"
											  name="name"
											  disabled
											  autocomplete="off"
											  :placeholder="$t('promo-to-product.invoice')"
								>
								</b-form-input>
							</b-col>
						</b-row>
					</b-form-group>
					<b-form-group v-if="!view">
						<b-row class="my-1">
							<b-col sm="3">
								<label>{{ $t('promo-to-product.regDate') }} <span
									class="text-danger">*</span></label>
							</b-col>
							<b-col sm="4">
								<date-picker
									style="margin-left: -16px"
									v-model="whDocument.regDate"
									lang="ru"
									:placeholder="$t('promo-to-product.regDate')"
									value-type="format"
									format="DD-MM-YYYY"
								></date-picker>
							</b-col>
						</b-row>
					</b-form-group>
					<b-form-group v-if="!view">
						<b-row class="my-1">
							<b-col sm="3">
								<label>{{ $t('promo-to-product.search') }} <span
									class="text-danger">*</span></label>
							</b-col>
							<b-col sm="6">
								<!--							<multiselect v-model="dropDowns.product.value"-->

								<multiselect
									v-model="form.whItems.itemId"
									:options="searchItems"
									:searchable="true"
									:show-labels="false"
									:internal-search="false"
									:close-on-select="true"
									label="name"
									track-by="id"
									@search-change="loadItems($event)"
									:placeholder="$t('incomes.create.product')">

									<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b> - </strong>{{ props.option.barcode }} / {{ props.option.artikul }} / {{
											props.option.colorName
										}} / {{
											props.option.size
										}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
										<span v-else>
										{{ props.option.artikul }} / {{
												props.option.barcode
											}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
									</template>

									<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b>  - </strong>{{ option.option.barcode }} / {{
											option.option.artikul
										}} / {{ option.option.colorName }} / {{
											option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
										<span
									> /<strong>{{ $t('sale.kol-vo') }}:</strong> {{
											option.option.count1
										}} / <strong>Цена:</strong> </span>
									</span>
										<span v-else>
										{{ option.option.artikul }} / {{
												option.option.barcode
											}} / {{
												option.option.name ? option.option.name.substring(0, 30) : ''
											}} <span
										> / <strong>{{ $t('sale.kol-vo') }}:</strong> {{
												option.option.count1
											}} / <strong>Цена:</strong>   {{ option.option.price }} </span>
									</span>
									</template>
								</multiselect>
							</b-col>
						</b-row>
					</b-form-group>
					<b-row v-if="!view">
						<b-col cols="3">
							<label>{{ $t('promo-to-product.oldPrice') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="3">
							<b>{{ form.whItems.itemId ? form.whItems.itemId.price : 0 }}</b>
						</b-col>
						<b-col cols="3">
							<label>{{ $t('incomes.balance') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="3">
							<b>{{ form.whItems.itemId ? form.whItems.itemId.count1 : 0 }}</b>
						</b-col>
					</b-row>
					<br v-if="!view">
					<b-row v-if="!view">
						<b-col cols="3">
							<label :for="form.whItems.priceUzs">{{ $t('promo-to-product.newPrice') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="3">
							<b-form-input size="sm" id="name"
										  v-model="form.whItems.priceUzs"
										  name="name"
										  autocomplete="off"
										  type="number"
										  :placeholder="$t('promo-to-product.newPrice')"
							>
							</b-form-input>
						</b-col>
						<b-col cols="3">
							<label :for="form.whItems.count">{{ $t('incomes.create.qty') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col cols="3">
							<b-form-input size="sm" id="name"
										  v-model="form.whItems.count"
										  name="name"
										  autocomplete="off"
										  type="number"
										  :placeholder="$t('promo-to-product.newCount')"
							>
							</b-form-input>
						</b-col>
						<b-col>
							<b-button
								type="button"
								size="sm"
								variant="outline-primary"
								@click="addItemBtn"
								class="mr-4"
							>
								{{ $t('incomes.create.add-item') }}
							</b-button>
						</b-col>
					</b-row>
					<b-row v-if="view" class="mb-3">
						<b-col align="center">
							<b>Акт № </b> {{ whDocument.regNumber }}
						</b-col>
					</b-row>
					<b-row v-if="view">
						<b-col>
							<b>{{ $t('promo-to-product.regDate') }}:</b> {{ whDocument.regDate }}
						</b-col>
						<b-col>
							<b>{{ $t('promo-to-product.department') }}:</b> {{ department.name ? department.name : '' }}
						</b-col>
						<b-col>
							<b>{{ $t('promo-to-product.from') }}:</b> {{ form.startDiscountDate }}
						</b-col>
						<b-col>
							<b>{{ $t('promo-to-product.finish-date') }}:</b> {{ form.endDiscountDate }}
						</b-col>
					</b-row>
					<b-form-group>
						<hr>
						<b-row class="generalTableClass">
							<b-table show-empty
									 striped hover
									 :items="addItems"
									 :fields="computedFields">
								<template slot="id" slot-scope="data">
									<!--								{{ data.index + 1 }}-->
									{{ paginate(data.index, searchForm.page, searchForm.limit) }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<div v-for="tmp in data.item.multiBarcodes">
										{{ tmp.barcode }}
									</div>
								</template>
								<template slot="artikul" slot-scope="data">
									<div v-for="(tmp,index) in data.item.vendorCodes" :key="`qwe-${index}`">
										{{ tmp.vendor }}
									</div>
								</template>
								<template slot="empty" slot-scope="scope">
									<span v-if="!selectAll">{{ $t('empty') }}</span>
									<div v-else class="bg-success p-2" style="width:100%;margin:0">
										<span style="font-size:18px">{{
												$t('promo-to-product.selected-all-items')
											}}</span>
									</div>
								</template>
								<template slot="actions" slot-scope="data">
									<div v-if="!view">
										<b-link @click="deleteSelectItem(data.index)">
											<i class="fa fa-trash"></i>
										</b-link>
									</div>
								</template>
							</b-table>

<!--							<nav>-->
<!--								<b-pagination :total-rows="total>0?total:totalForEdit" :per-page="searchForm.limit"-->
<!--											  v-model="searchForm.page"-->
<!--											  :prev-text="$t('pagination.prev')"-->
<!--											  :next-text="$t('pagination.next')" hide-goto-end-buttons/>-->
<!--							</nav>-->

						</b-row>
					</b-form-group>
				</ValidationObserver>
			</b-container>

			<div v-if="!view" class="modal-actions">
				<b-row class="align-items-center" style="padding-bottom: 10px">
					<b-col cols="8" class="mb-3 mb-xl-0" style="padding-top: 45px;">
						<b-row>
							<b-col cols="4">
								<b-button block size="sm" type="button" @click="cancel" :disabled="loadingForNewPromo" variant="outline-danger">
									<b-spinner v-if="loading" small/>
									{{ $t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="4">
								<b-button block type="button" size="sm" @click="save('SUSPENDED')" :disabled="loadingForNewPromo" variant="primary">
									<b-spinner v-if="loading" small/>
									{{ $t('save') }}
								</b-button>
							</b-col>
							<b-col v-if="$can('pricing', 'manager')" cols="4">
								<b-button @click="save('READY')" variant="btn btn-success" block size="sm">
									<b-spinner v-if="loading" small/>
									<i class="fa fa-save"></i> &nbsp;
									<span>{{ $t('warehouse.document.saveAndFinish') }}</span>
								</b-button>
							</b-col>
							<b-col cols="2">
								<!-- SMALL LOADER -->
								<b-spinner v-if="loadingForNewPromo" small class="ml-2" variant="primary" label="Small Spinner"></b-spinner>
								<!-- SMALL LOADER -->
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</form>

		<b-modal v-model="dateConfirmModal" @ok="confirmDateDoc(true)" @cancel="confirmDateDoc(false)" title="Подтвердите" size="sm" button-size="sm" ok-variant="success" ok-title="Да" cancel-variant="danger" cancel-title="Нет" centered no-close-on-backdrop no-close-on-esc>
			<p>Вы не сохраняете Накладной с сегодняшней датой. Если вы уверены то нажмите да, в противном случи оно сохранится с сегодняшней датой !</p>
		</b-modal>
	</div>
</template>

<script>
import AddChildren from "./AddChildren";
import {validators} from "../mixins/validators";
import PromoService from "../../../../services/promo.service";
import MaskedInput from 'vue-masked-input'
import {mapGetters, mapActions, mapState} from 'vuex'
import Multiselect from 'vue-multiselect'
import WhDocument from '../../../../services/wh-document.service'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
	name: 'OneTimeDiscountTabs',
	props: {
		mode: {
			type: String,
			default: 'create'
		},
		view: {
			type: Boolean,
			default: false
		},
		edit: {
			type: Object,
			default: null
		},
		totalForEdit: {
			type: Number,
			default: 0
		}


	},
	mixins: [validators],
	data() {
		return {
			loading: false,
			dateConfirmModal: false,
			addItems: [],
			selectedDepId: null,
			searchItems: [],
			fromDate: '',
			toDate: '',
			whDocument: {},
			search: {
				page: 1,
				limit: 20,
				attributes: []
			},
			selectAll: false,
			computedFields: [
				{
					key: 'id',
					label: '№',
					'class': 'width8_wordBreak',
					sortable: true
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('goods.name'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					visible: true,
					changebale: true
				},
				{
					key: 'termOfItem',
					label: this.$t('kirim.expirationDate'),
					visible: false,
					changebale: true
				},
				{
					key: 'oldPriceUzs',
					label: this.$t('promo-to-product.oldPrice'),
					'class': 'not-first',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'count1Old',
					label: this.$t('incomes.balance'),
					'class': 'incomeItemSize',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'priceUzs',
					label: this.$t('promo-to-product.newPrice'),
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.qty'),
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'actions',
					label: this.$t('actions.title'),
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				}
			],
			total: 0,
			// newMessForSpisok: '',
			// responseArray: [],
			createPromo: {
				comment: '',
				start: '',
				finish: '',
				status: null,
				itemsList: [],
				selectedIds: [],
				itemsUnnecessary: [],
				name: '',
				promotionType: null,
				discount: '',
				deps: [],
				promoX: 0,
				promoN: 0,

			},
			searchForm: {
				page: 1,
				limit: 20,
			},
			newPromo: null,
			promotionPlusForUpdate: [],
			promotionMinusForUpdate: [],
			childModal: false,
			loadingForNewPromo: false,
			department: null,
			form: {
				id: null,
				toDepartmentId: null,
				startDiscountDate: null,
				endDiscountDate: null,
				action: 'DISCOUNT',
				documentType: 'ONE_TIME',
				documentStatus: null,
				whItems: {
					itemId: null,
					priceUzs: '',
					oldPriceUzs: '',
					count: null,
					documentId: null,
				}
			}
		}
	},
	methods: {
		...mapState('warehouse', [
			'pricingItem', 'balance', 'customDepartments',
			'currentItemBalanceError', 'currentPricingItemError', 'itemsNotKirim', 'priceIsNotDifferent',
			'foundItemsFromXls', 'notFoundItemsFromXls', 'depSaleType'
		]),
		...mapActions('promo', ['fetchDepartment', 'searchDoubleDiscountStore']),
		...mapActions('references', ['getReferenceChildren']),
		...mapActions('departments', ['fetchMyDepartments']),
		deleteSelectItem(id) {
			this.addItems.map(item => {
				if (item.id === id) {
					this.addItems.splice(id, 1);
				}
			});
		},
		print() {
			window.print();
		},
		addItemBtn() {
			if (this.addItems && this.addItems.length > 0) {
				let index = null,
					item = {};
				this.addItems.forEach((t, i) => {
					if (t.itemId === this.form.whItems.itemId.id && t.incomeDocId == this.form.whItems.itemId.incomeDocId) {
						index = i
						item = t
					}
				})
				if (index != null) {
					this.addItems.splice(index, 1);
					let sum = Number(item.count) + Number(this.form.whItems.count)
					if (item.count1Old >= sum) {
						item.count = sum
						this.form.whItems.itemId = {}
						this.form.whItems.priceUzs = ''
						this.form.whItems.count = ''
						this.form.whItems.itemId.price = 0
						this.form.whItems.itemId.count1 = 0
					} else
						this.$vs.notify({
							title: `Количество не должен быть больше чем ${item.count1Old} !`,
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					this.addItems.unshift(item);
				} else {
					if (this.form.whItems.itemId.count1 >= this.form.whItems.count) {
						let currentObj = {
							id: this.addItems.length,
							name: this.form.whItems.itemId.name,
							barcode: this.form.whItems.itemId.barcode,
							multiBarcodes: this.form.whItems.itemId.multiBarcodes,
							termOfItem: this.form.whItems.itemId.termOfItem,
							artikul: this.form.whItems.itemId.artikul,
							vendorCodes: this.form.whItems.itemId.vendorCodes,
							itemId: this.form.whItems.itemId.id,
							incomeDocId: this.form.whItems.itemId.incomeDocId,
							priceUzs: this.form.whItems.priceUzs,
							oldPriceUzs: this.form.whItems.itemId.price,
							count1Old: this.form.whItems.itemId.count1,
							count: this.form.whItems.count,
							price: this.form.whItems.itemId.price
						}
						this.addItems.push(currentObj)
						this.form.whItems.itemId = {}
						this.form.whItems.priceUzs = ''
						this.form.whItems.count = ''
						this.form.whItems.itemId.price = 0
						this.form.whItems.itemId.count1 = 0
					} else {
						this.$vs.notify({
							title: `Количество не должен быть больше чем ${this.form.whItems.itemId.count1} !`,
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
			} else {
				if (this.form.whItems.itemId.count1 >= this.form.whItems.count) {
					let currentObj = {
						id: this.addItems.length,
						name: this.form.whItems.itemId.name,
						barcode: this.form.whItems.itemId.barcode,
						multiBarcodes: this.form.whItems.itemId.multiBarcodes,
						termOfItem: this.form.whItems.itemId.termOfItem,
						artikul: this.form.whItems.itemId.artikul,
						vendorCodes: this.form.whItems.itemId.vendorCodes,
						itemId: this.form.whItems.itemId.id,
						incomeDocId: this.form.whItems.itemId.incomeDocId,
						priceUzs: this.form.whItems.priceUzs,
						oldPriceUzs: this.form.whItems.itemId.price,
						count1Old: this.form.whItems.itemId.count1,
						count: this.form.whItems.count,
						price: this.form.whItems.itemId.price
					}
					this.addItems.push(currentObj)
					this.form.whItems.itemId = {}
					this.form.whItems.priceUzs = ''
					this.form.whItems.count = ''
					this.form.whItems.itemId.price = 0
					this.form.whItems.itemId.count1 = 0
				} else {
					this.$vs.notify({
						title: `Количество не должен быть больше чем ${this.form.whItems.itemId.count1} !`,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			}
		},
		async loadItems($event) {
			await this.getListByProductsNotKirimFunction(this.selectedDepId, $event)
		},
		async getListByProductsNotKirimFunction(id, keyword) {
			await WhDocument.getListByProductsNotKirimServiceFunctionNew(id, keyword).then(response => {
				this.searchItems = response.data;
			})
		},
		createOneTimeDiscountDoc() {
			this.loader = true;
			PromoService.createOneTimeDiscountDoc({action: 'DISCOUNT', documentType: 'ONE_TIME'}).then(response => {
				this.whDocument = response.data;

				this.form.toDepartmentId = this.department.id;
				this.form.id = this.whDocument.id;

				this.total = response.data.total;
				this.loader = false;
			}).catch(() => {
				this.loader = true;
			});
		},
		cancel() {
			this.$emit('close', true);
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getTodayDate() {
			let today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();
			today = dd + '-' + mm + '-' + yyyy;
			return String(today);
		},
		save(status) {
			this.$refs.oneTimeDiscountObserver.validate().then(valid => {
				if (valid) {
					this.form.whItems = this.makeWhItems()
					this.loading = true;
					if (status === 'READY') {
						if (this.form.regDate !== this.getTodayDate()) {
							this.dateConfirmModal = true
							return false;
						} else {
							this.form.documentStatus = status
							this.form.regNumber = this.whDocument.regNumber
							this.form.regDate = this.whDocument.regDate
							this.form.toDepartmentId = this.department.id
							this.form.id = this.whDocument.id
							PromoService.editOneTimeDiscountDoc(this.form).then(response => {
								this.loading = false;
								this.$emit('success', true);
							}).catch(() => {
								this.loading = false;
							});
						}
					} else if (status === 'SUSPENDED') {
						this.form.documentStatus = status
						this.form.regNumber = this.whDocument.regNumber
						this.form.regDate = this.whDocument.regDate
						this.form.toDepartmentId = this.department.id
						this.form.id = this.whDocument.id
						PromoService.editOneTimeDiscountDoc(this.form).then(response => {
							this.loading = false;
							this.$emit('success', true);
						}).catch(() => {
							this.loading = false;
						});
					}
				} else {
					this.$refs.department.$attrs.class = 'valid'
				}
			})
		},
		confirmDateDoc(tmp) {
			if (tmp) {
				this.form.documentStatus = 'READY'
				this.form.regNumber = this.whDocument.regNumber
				this.form.regDate = this.whDocument.regDate
				this.form.toDepartmentId = this.department.id
				this.form.id = this.whDocument.id
				PromoService.editOneTimeDiscountDoc(this.form).then(response => {
					this.dateConfirmModal = false
					this.loading = false;
					this.$emit('success', true);
				}).catch(() => {
					this.loading = false;
				});
			} else {
				this.form.documentStatus = 'READY'
				this.form.regNumber = this.whDocument.regNumber
				this.form.regDate = this.getTodayDate()
				this.form.toDepartmentId = this.department.id
				this.form.id = this.whDocument.id
				PromoService.editOneTimeDiscountDoc(this.form).then(response => {
					this.dateConfirmModal = false
					this.loading = false;
					this.$emit('success', true);
				}).catch(() => {
					this.loading = false;
				});
			}
		},
		makeWhItems() {
			let whItems = [];
			for (let i = 0; i < this.addItems.length; i++) {
				let whItem = {
					itemId: this.addItems[i].itemId,
					priceUzs: this.addItems[i].priceUzs,
					termOfItem: this.addItems[i].termOfItem ? this.addItems[i].termOfItem : null,
					incomeDocId: this.addItems[i].incomeDocId,
					oldPriceUzsForOneTimeDiscount: this.addItems[i].oldPriceUzs,
					count: this.addItems[i].count,
					documentId: this.whDocument.id,
				};
				whItems.push(whItem)
			}
			return whItems
		},
		convertOneTimeDiscountDoc() {
			this.department = {
				id: this.oneTimeDiscountDoc.toDepartmentId,
				name: this.oneTimeDiscountDoc.toDepartmentName
			}

			this.form.startDiscountDate = this.oneTimeDiscountDoc.startDiscountDate
			this.form.endDiscountDate = this.oneTimeDiscountDoc.endDiscountDate
			this.form.regNumber = this.oneTimeDiscountDoc.regNumber
			this.form.regDate = this.oneTimeDiscountDoc.regDate

			this.whDocument.id = this.oneTimeDiscountDoc.id
			this.whDocument.regNumber = this.oneTimeDiscountDoc.regNumber
			this.whDocument.regDate = this.oneTimeDiscountDoc.regDate
			// this.form.whItems = {
			// 	id: this.oneTimeDiscountDoc.itemId,
			// 	name: this.oneTimeDiscountDoc.name
			// }

			for (let i = 0; i < this.oneTimeDiscountDoc.whItems.length; i++) {

				let currentObj = {
					id: i,
					name: this.oneTimeDiscountDoc.whItems[i].itemName,
					artikul: this.oneTimeDiscountDoc.whItems[i].artikul,
					vendorCodes: this.oneTimeDiscountDoc.whItems[i].vendorCodes,
					barcode: this.oneTimeDiscountDoc.whItems[i].barcode,
					multiBarcodes: this.oneTimeDiscountDoc.whItems[i].multiBarcodes,
					termOfItem: this.oneTimeDiscountDoc.whItems[i].termOfItem,
					itemId: this.oneTimeDiscountDoc.whItems[i].itemId,
					incomeDocId: this.oneTimeDiscountDoc.whItems[i].incomeDocId,
					priceUzs: this.oneTimeDiscountDoc.whItems[i].priceUzs,
					oldPriceUzs: this.oneTimeDiscountDoc.whItems[i].oldPriceUzsForOneTimeDiscount,
					count1Old: this.oneTimeDiscountDoc.whItems[i].realBalance,
					count: this.oneTimeDiscountDoc.whItems[i].count,
				}
				this.addItems.push(currentObj)
			}

			this.form.whItems = this.addItems

		}
	},
	created() {
		// this.fetchDepartment()
		this.fetchMyDepartments();
		this.getReferenceChildren("Promotion_type")
		if (this.mode === 'create') {
			this.createOneTimeDiscountDoc();
			this.nvSpiskaDisabledButton = true;
			this.dobavitDisabledButton = false;
			this.newPromo = this.createPromo
			// this.totalForEdit = 0;
		} else if (this.mode === 'edit' || this.mode === 'view') {
			this.convertOneTimeDiscountDoc();
		} else {
			let obj = Object.assign({}, this.edit)

			obj.selected = []
			obj.selectedIds = []
			this.edit.itemsList.forEach(item => {
				obj.selected.push({
					wrappedId: item.id,
					colorName: item.colorName,
					artikul: item.artikul,
					model: item.model,
					sku: item.sku,
					barcode: item.barcode,
					size: item.size,
					name: item.name,
				});

				obj.selectedIds.push(item.id)
			})
			obj.itemsList = obj.selected
			// this.promotionPlusForUpdate = obj.itemsList;


			obj.deps = obj.departmentsList
			obj.promotionType = obj.promotionType === "%" ? "PERCENTAGE" : obj.promotionType,
				this.newPromo = obj;
			this.nvSpiskaDisabledButton = false;
			this.dobavitDisabledButton = false;

		}
	},
	computed: {
		listWarehouse() {
			return this.myDepartments.filter(item => {
				return item;
			})
		},
		...mapActions('warehouse', [
			'getListByProductsNotKirim',
		]),
		...mapGetters('departments', [
			'myDepartments'
		]),
		...mapState('promo', [
			'oneTimeDiscountDoc'
		]),
	},
	watch: {
		'department': {
			deep: true,
			async handler(value) {
				if (value) {
					this.selectedDepId = value.id
					await this.getListByProductsNotKirimFunction(this.selectedDepId, null);
				} else {
					this.searchItems = []
				}
			}
		},
	},
	components: {
		AddChildren,
		MaskedInput,
		Multiselect,
		ValidationObserver,
		ValidationProvider
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
#newPromoId {
	.form-group {
		margin-bottom: .5rem;
	}
}

.invalid .multiselect__tags {
	border-color: red;
}

.addItemsModalHeader {
	display: flex;
	width: 100%;
	justify-content: space-between;

	.close {
		font-size: 18px;
	}
}

.valid {
	border-color: red;
}

.invalid {
}
@media print {
	.hidden-print {
		display: none;
	}
}
</style>
